import "@/App.css";
import "@/legion.css";
import "@/lib/api";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import MemberPage from "@/pages/MemberPage";
import DeckPage from "@/pages/DeckPage";
import JoinPage from "@/pages/JoinPage";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<MemberPage />} />
        <Route path="/deck" element={<DeckPage />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
